<template>
    <div class="update_paperpile_info_popup">
        <div class="paperpile_popup_center">
            <div class="paperpile_popup_scroll">
                <div class="paperpile_popup_modal create_meeting_popup">
                    <div class="paperpile_popup_header">
                        <h4>Paper Info</h4>
                        <span class="paperpile_popup_close">
                            <i class="fa fa-times-circle-o" v-on:click="closeUpdatePaperInfoPopup()"></i>
                        </span>
                    </div>
                    <div class="paperpile_popup_body create_meeting_popup_body">
                        <form @submit.prevent="updatePaperpileBeforeSubmitMethod">
                            <div class="form-group">
                                <label>Title</label>
                                <input type="text" class="form-control" v-validate="'required'" v-model="topic"
                                    name="topic" v-bind:class="{ 'is-invalid': errors.has('topic') && submitted }"
                                    data-vv-as="title" :readonly="!paperUpdateINFO.is_uploaded">
                                <small class="invalid-feedback" v-if="errors.has('topic')">{{ errors.first('topic')
                                }}</small>
                            </div>
                            <div class="form-group">
                                <label>Author</label>
                                <input type="text" class="form-control" v-model="author" name="author">
                            </div>
                            <div class="form-group">
                                <label>Journal</label>
                                <input type="text" class="form-control" v-model="journal">
                            </div>
                            <div class="form-group">
                                <label>Abstract</label>
                                <textarea rows="3" class="form-control" v-model="abstract"></textarea>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>ID</label>
                                        <input type="text" class="form-control" v-model="pdf_id">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Pages</label>
                                        <input type="number" class="form-control" v-model="page_no">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Volume</label>
                                        <input type="text" class="form-control" v-model="volume">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group custom_ui_of_datetim_field">
                                        <label>Year</label>
                                        <select class="form-control pr-0 text-center" v-model="publisher">
                                            <option value="" class="text-left">Please Select</option>
                                            <option class="text-left" v-for="(item, index) in yearList" :key="index"
                                                :value="item">{{ item }}</option>
                                        </select>
                                        <!-- <datetime v-model="publisher" type="date"></datetime> -->
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Issue</label>
                                        <input type="text" class="form-control" v-model="issue">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Number</label>
                                        <input type="text" class="form-control" v-model="number">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <button type="submit" class="btn btn-primary paperpile_btn"
                                        :disabled="isSubmitted">Save</button>
                                </div>
                                <!-- <div class="col-sm-6 text-right">
                <span class="btn btn-danger" @click="dataRefreshedMethod()">Refresh</span>
              </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {bus} from '@/main';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let checkMetadataOfPaperApiUrl = root.checkMetadataOfPaperApiUrl.link;
export default {
    name: 'update-paperpile-details',
    components: {
    },
    props: ['paperUpdateINFO'],
    data() {
        return {
            submitted: false,
            author: '',
            journal: '',
            topic: '',
            page_no: '',
            volume: '',
            publisher: '',
            number: '',
            abstract: '',
            pdf_id: '',
            issue: '',
            isSubmitted: false,
            yearList: [
                1950,
                1951,
                1952,
                1953,
                1954,
                1955,
                1956,
                1957,
                1958,
                1959,
                1960,
                1961,
                1962,
                1963,
                1964,
                1965,
                1966,
                1967,
                1968,
                1969,
                1970,
                1971,
                1972,
                1973,
                1974,
                1975,
                1976,
                1977,
                1978,
                1979,
                1980,
                1981,
                1982,
                1983,
                1984,
                1985,
                1986,
                1987,
                1988,
                1989,
                1990,
                1991,
                1992,
                1993,
                1994,
                1995,
                1996,
                1997,
                1998,
                1999,
                2000,
                2001,
                2002,
                2003,
                2004,
                2005,
                2006,
                2007,
                2008,
                2009,
                2010,
                2011,
                2012,
                2013,
                2014,
                2015,
                2016,
                2017,
                2018,
                2019,
                2020,
                2021,
                2022,
                2023
            ]
        }
    },
    computed: {

    },
    mounted() {
        this.topic = this.paperUpdateINFO.title || '';
        this.author = this.paperUpdateINFO.author || '';
        this.abstract = this.paperUpdateINFO.abstract || '';
        this.journal = this.paperUpdateINFO.journal || '';
        this.publisher = this.paperUpdateINFO.year || '';
        this.pdf_id = this.paperUpdateINFO.pdf_id || '';
        this.volume = this.paperUpdateINFO.volume || '';
        this.issue = this.paperUpdateINFO.issue || '';
        this.number = this.paperUpdateINFO.number || '';
        this.page_no = this.paperUpdateINFO.pages || '';
    },
    methods: {
        getPaperPileListAgain() {
            this.$store.dispatch('getAllPaperPileFun');
        },
        updatePaperpileBeforeSubmitMethod() {
            this.$validator.validateAll().then((result) => {
                this.submitted = true
                if (result) {
                    this.isSubmitted = true
                    let payload = {
                        title: this.topic,
                        author: this.author,
                        abstract: this.abstract,
                        journal: this.journal,
                        year: this.publisher,
                        volume: this.volume,
                        number: this.number,
                        issue: this.issue,
                        pages: this.page_no,
                        pdf_id: this.pdf_id,
                        id: this.paperUpdateINFO.id
                    }
                    axios.post(checkMetadataOfPaperApiUrl, payload)
                        .then((res) => {
                            toast.success(res.data.msg || "Request processed successfully.");
                            this.getPaperPileListAgain();
                            this.closeUpdatePaperInfoPopup();
                            this.submitted = false;
                            this.isSubmitted = false;
                        }).catch((err) => {
                            this.submitted = false;
                            this.isSubmitted = false;
                            toast.error(err.data.user_msg || err.data.msg);
                        })
                    return;
                }
            })
        },
        closeUpdatePaperInfoPopup() {
            bus.$emit('updatePaperPileDetailPopupStateBus', false);
            bus.$emit('addPaperPilePopupStateBus', false);
            bus.$emit('uploadPaperStateBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        }
    }
}
</script>

<style lang="scss" scoped>
.update_paperpile_info_popup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    display: table;
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .paperpile_popup_center {
        overflow-y: auto;
        height: 100dvh;
        display: table-cell;
        vertical-align: middle;
    }

    .paperpile_popup_scroll {
        overflow-y: auto;
        max-height: 100dvh;
        padding: 0 15px;
    }

    .paperpile_popup_modal {
        background: #000;
        max-width: 640px;
        margin: 0 auto;
        border-radius: 5px;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .paperpile_popup_close {
        position: absolute;
        top: 15px;
        right: 10px;
        line-height: 1;

        .fa {
            font-size: 26px;
            color: red;
            cursor: pointer;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -webkit-transition: all ease 0.5s;
            transition: all ease 0.5s;

            &:hover {
                color: #87cefa;
            }
        }
    }

    .paperpile_popup_header {
        padding: 15px;
        position: relative;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);

        h4 {
            font-size: 28px;
            letter-spacing: 0;
            margin-bottom: 0;
        }
    }

    .paperpile_popup_body {
        padding: 15px;

        label {
            font-size: 16px;
            margin-bottom: 4px;
        }

        .form-control {
            width: 100%;
            font-weight: normal;
            font-size: 18px;
            border-radius: 5px;
            height: 48px;
            padding: 10px 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            outline: none !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            color: #ffd400;
            background: rgba(255, 255, 255, 0.08);

            &:focus {
                border-color: #ffd400;
            }

            option {
                color: #000000;
            }
        }

        textarea.form-control {
            height: auto;
        }

        .mx-datepicker {
            width: 100%;
        }

        .invalid-feedback {
            font-size: 14px;
            line-height: 1;
        }
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.12) !important;
        color: #ffffff !important;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;

        &:hover {
            background: #87cefa !important;
            color: #22292f !important;
        }
    }
}
</style>